export const ConfigurationModes = Object.freeze({
    Default: { domAttr: "default" },

    Wizard: { domAttr: "wizard" },

    SubConfigurationComplex: { domAttr: "subconfig-complex" },

    SubConfigurationInline: { domAttr: "subconfig-inline" },

    SubConfigurationTopMenu: { domAttr: "subconfig-topmenu" }
});